export async function setCurrentWebStationId(
  webStationId: string
): Promise<Response> {
  try {
    return await fetch('/api/user/setCurrentWebStationId', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ webStationId }),
    });
  } catch (err) {
    throw new Error(err.message);
  }
}
